import axios from 'axios';
import {BillSearchResponse} from '../../interfaces/bill';
import {PaymentAddress} from '../../interfaces/payment-address';
import {Rib} from '../../interfaces/rib';
import {DocuSignSepaFormData, DocuSignUrl} from '../../interfaces/docusign';

export const getBills = async () => {
    const response = await axios.get<BillSearchResponse[]>(`/api/billing/bills`);
    return response.data;
};

export const getPaymentAddress = async (clientId: string) => {
    const response = await axios.get<PaymentAddress>(`/api/customers/${clientId}/billing/address`);
    return response.data;
};

export const editPaymentAddress = async (paymentAdress: PaymentAddress, clientId: string) => {
    const response = await axios.put<PaymentAddress>(
        `/api/customers/${clientId}/billing/address`,
        paymentAdress
    );
    return response.data;
};

export const getRib = async (clientId: string) => {
    const response = await axios.get<Rib>(`/api/customers/${clientId}/billing/rib`);
    return response.data;
};

export const editRib = async (rib: Rib, clientId: string): Promise<boolean> => {
    const response = await axios.put<Rib>(`/api/customers/${clientId}/billing/rib`, rib);
    return response.status === 204;
};

export const createDocuSignSepaUrl = async (
    docuSignSepaFormData: DocuSignSepaFormData,
    clientId: string
) => {
    const response = await axios.post<DocuSignUrl>(
        `/api/customers/${clientId}/docusign/sepa`,
        docuSignSepaFormData
    );
    return response.data;
};
